import { LanguageType } from "@libs/i18n";
import { I18nKeyType } from "@/i18n";

import {
  ARABIC_NATIVE_TITLE,
  CHINESE_SIMPLIFIED_NATIVE_TITLE,
  ENGLISH_NATIVE_TITLE,
  HAITIAN_CREOLE_NATIVE_TITLE,
  RUSSIAN_NATIVE_TITLE,
  SPANISH_NATIVE_TITLE,
  TAGALOG_NATIVE_TITLE,
  VIETNAMESE_NATIVE_TITLE,
} from "./constants";

export type LanguageOptionType = {
  language: string;
  descriptionI18nKey: I18nKeyType;
  locale: LanguageType;
};

export type PendingLanguageType = {
  language: LanguageType;
  authUserId: string | null;
};

export const languageOptions: LanguageOptionType[] = [
  {
    language: ENGLISH_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.englishDescription",
    locale: "en",
  },
  {
    language: SPANISH_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.spanishDescription",
    locale: "es",
  },
  {
    language: CHINESE_SIMPLIFIED_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.chineseSimplifiedDescription",
    locale: "zh",
  },
  {
    language: VIETNAMESE_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.vietnameseDescription",
    locale: "vi",
  },
  {
    language: RUSSIAN_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.russianDescription",
    locale: "ru",
  },
  {
    language: ARABIC_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.arabicDescription",
    locale: "ar",
  },
  {
    language: TAGALOG_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.tagalogDescription",
    locale: "tl",
  },
  {
    language: HAITIAN_CREOLE_NATIVE_TITLE,
    descriptionI18nKey: "native:languages.haitianCreoleDescription",
    locale: "ht",
  },
];
